import React from 'react'

const TabPanel = ({ children, isActive }) => {
    const style = { display: isActive ? 'block' : 'none' };
    return <div style={style}>{children}</div>;
};

export default TabPanel